export default "__VITE_ASSET__DW0I25qy__"